import { styled, Box, Paper, Typography } from "@mui/material";

export const CartContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1),
  },
}));

export const CartItemsContainer = styled(Paper)(({ theme }) => ({
  border: "1px solid #ccc",
  borderRadius: theme.shape.borderRadius * 2,
  maxHeight: 730,
  overflowY: "auto",
  maxWidth: "100%",
  overflowX: "hidden",
  [theme.breakpoints.down("md")]: {
    maxHeight: "none",
  },
}));

export const OrderSummaryContainer = styled(Paper)(({ theme }) => ({
  border: "1px solid #ccc",
  borderRadius: theme.shape.borderRadius * 2,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  maxWidth: "100%",
  overflowX: "hidden",
}));

export const EmptyCartContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  width: "100%",
  padding: theme.spacing(3),
  gap: theme.spacing(2),
  minHeight: 250,
  [theme.breakpoints.up("sm")]: {
    minHeight: 350,
    padding: theme.spacing(4),
    gap: theme.spacing(3),
  },
  [theme.breakpoints.up("md")]: {
    minHeight: 400,
    padding: theme.spacing(5),
    gap: theme.spacing(4),
  },
}));

export const EmptyCartImage = styled("img")(({ theme }) => ({
  width: 100,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    width: 120,
  },
  [theme.breakpoints.up("md")]: {
    width: 150,
  },
}));

export const EmptyCartText = styled(Typography)(({ theme }) => ({
  color: "#828282",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 400,
  fontSize: "1rem",
  lineHeight: 1.6,
  maxWidth: "90%",
  [theme.breakpoints.up("sm")]: {
    fontSize: "1.125rem",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "1.25rem",
  },
}));

export const CartLayout = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(8),
  position: "relative",
  top: 0,
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    gap: theme.spacing(10),
    top: -38,
    "@media (max-width: 1100px)": {
      flexDirection: "column",
      "& > *": {
        width: "100% !important",
      },
    },
  },
}));

export const CartItemsWrapper = styled(Box)(({ theme }) => ({
  flex: 2,
  width: "100%",
  [theme.breakpoints.up("md")]: {
    width: "60%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "70%",
  },
}));

export const OrderSummaryWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  width: "100%",
  marginTop: theme.spacing(2),
  [theme.breakpoints.up("md")]: {
    width: "40%",
    marginTop: 0,
  },
  [theme.breakpoints.up("lg")]: {
    width: "30%",
  },
}));

export const BackButton = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));
